export default "__VITE_ASSET__Cw3ookaU__"